
const { creditPacks } = require('../utilities/Constants');

const logOutUser = (event) => 
{
    localStorage.removeItem('AuthToken');
    localStorage.removeItem('RefreshToken');
    window.location.href = '/pricing';
}

function formatCredits(value) {
    return Number(value || 0).toLocaleString('en-US');
}

function PricingPageHTML(props) {
    return (

<html lang="en">
    <head>
        <meta charset="UTF-8"/>
        <title>Pricing | GoRepa</title>
        <meta name="description" content="Compare GoRepa plans and choose the best for you. We have plans for everyone." />
        <meta name="keywords" content="real estate analysis pricing" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width,initial-scale=1.0" />
     
        <meta property="og:url" content="https://gorepa.com/pricing.html" />
        <meta property="og:type" content="" />
        <meta property="og:title" content="Pricing | GoRepa" />
        <meta property="og:description" content="Compare GoRepa plans and choose the best for you. We have plans for everyone." />
        <meta property="og:image" content="" />
        <meta name="twitter:image" content="" />
        <link rel="canonical" href="https://gorepa.com/pricing.html" />
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        {/* <link rel="stylesheet" type="text/css" href="css/style.css" /> */}

        <script src="js/jquery-3.5.1.min.js"></script>
        <script type="text/javascript" src="js/sites-scripts.js"></script>
      
        {/*
      <link rel="stylesheet" type="text/css" href="css/page-specific/pricing.css" />
    */}
 
      </head>

      <body class="bodyStyle">

        <div class="pricePagecontent ">
        
            <div class="pricePagegr-encloser-cookie " id="cookie-policy-banner">
        
                <div class="pricePagegr-cookie-container ">
                    <div class="pricePagegr-cookie-enclosure ">
                        <div class="pricePagegr-cookie-head pricePagegr-space-fix ">
                            <div class="pricePagegr-cookie-title ">
                                This Site Uses Cookies
                            </div>
                            <div class="pricePagegr-cookie-permission " id="cookieAllow" onclick="cookieAccept();">
                                Allow
                            </div>
                        </div>
                        <div class="pricePagegr-cookie-content ">
                            <div>
                                We use cookies to enhance site navigation, analyze site usage, and assist us to improve your website experience as set out in our <a href="/cookie-policy.html">Cookie Policy</a>.
                            </div>
                                                                        </div>
                                                                                </div>
                </div>
            </div>
           
            {/* START Header */}

            <header class="pricePageheader " id="theHeader">

            <div class="pricePagerow pricePagegr-mobile-top-menu-encloser ">
            <div id="mobilePrimaryMenu">
                <div class="pricePagenavbar-header ">
                    <div class="pricePagegr-mobile-menu-wrap pricePagegr-space-fix ">
                        <div class="pricePagegr-mobile-menu-left-side pricePagegr-space-fix ">
                            <div class="pricePagegr-hamburger-button ">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div class="pricePagegr-mobile-menu-logo-container ">
                                <a href="/" title="">
                                    <img class="pricePagelogo pricePagescrollView " src={props.images.propertyAnalyticsLogo} alt="real estate property analytics" />
                                </a>
                            </div>
                        </div>
                        <div class="pricePagegr-mobile-menu-right-side pricePagegr-space-fix ">
                            <div class="pricePagegr-tablet-tick-contact-container ">
                                <a class="pricePagebtn pricePagenormal pricePagegr-gtitem-blue " href="/login">
                                                                             LOGIN
                                </a>
                            </div>
                            
                            {!props.isUserLoggedIn && 
                            <div class="pricePagegr-mobile-menu-signup-container ">
                                <a class="pricePagebtn pricePagenormal pricePagegreen " href="/pricing">
                                    SIGN UP for FREE
                                </a>
                            </div>
                            }

                            {props.isUserLoggedIn && 
                            <div class="pricePagegr-mobile-menu-signup-container ">
                                <div class="pricePagebtn pricePagenormal pricePagegreen " onClick={logOutUser}>
                                    LOGOUT
                                </div>
                            </div>
                            }
                            
                            <div class="pricePagegr-mobile-menu-login-container ">
                                <a href="/login">
                                    <img class="pricePagegr-menu-login-icon " src="images/login-icon-blue.png" alt="Login" border="0" />
                                </a>
                            </div>
                            <div class="pricePagegr-tablet-tick-button-container ">
                                <a href="/signup">
                                    <img class="pricePagegr-menu-login-icon " src="images/search-icon-blue.png" alt="Login" border="0" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="pricePagegr-tablet-special-search " id="tabletChannelSearch">
                        <div class="pricePagegr-tablet-tick-field-enclosure " id="channel-search">

                        </div>
                    </div>
                </div>
                <div class="pricePagenavbar-collapse pricePageignore-additional-spaces pricePagegr-mobile-secondary-menu ">
                    <ul class="pricePagenav pricePagenavbar-nav ">
        
                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                        <li class="pricePagedropDown " id="SOLUTIONS">
                            <a data-path="SOLUTIONS" class="pricePagemenuNoLink pricePagedropdown-toggle ">
                                SOLUTION
                            </a>
                            <ul class="pricePagedropDownMobile ">
                                <li class="pricePagemobileSubtitle ">
                                    <a href="/homebuyers.html" class="">
                                        BY INVESTOR TYPE
                                    </a>
                                </li>
                                <li>
                                    <a href="/homebuyers.html" class="">
                                        For Home Buyers
                                    </a>
                                </li>
                                <li>
                                    <a href="/property-flipping-investors.html" class="">
                                        For House Flipping Investors
                                    </a>
                                </li>
                                <li>
                                    <a href="/rental-property-investors.html" class="">
                                        For Rental Property Investors
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                        <li class="pricePagedropDown " id="COMPANY">
                            <a data-path="COMPANY" class="pricePagemenuNoLink pricePagedropdown-toggle ">
                                COMPANY         
                            </a>
                            <ul class="pricePagedropDownMobile ">
                                <li>
                                    <a href="/about.html" class="">
                                        About Us
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                        {/*
                        <li class="">
                            <a href="/pricing" class="pricePagemenuNoLink pricePagedropdown-toggle ">
                                PRICING
                            </a>
                        </li>
                        */}
                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                        <li class="pricePagedropDown " id="Resources">
                            <a data-path="Resources" class="pricePagemenuNoLink pricePagedropdown-toggle ">
                                Resources
                            </a>
                            <ul class="pricePagedropDownMobile ">
                                <li>
                                    <a href="/blog" >
                                        Blog
                                    </a>
                                </li>
                                <li>
                                    <a href="/faq.html" class="">
                                        FAQ
                                    </a>
                                </li>

                            </ul>
                        </li>
                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                        <li class="pricePagedropDown " id="Support">
                            <a data-path="Support" class="pricePagemenuNoLink pricePagedropdown-toggle ">
                                Support
                            </a>
                            <ul class="pricePagedropDownMobile ">
                                <li>
                                    <a href="/faq.html" >
                                        FAQ
                                    </a>
                                </li>
                       
                                <li>
                                    <a href="/contactus" >
                                        Contact Us
                                    </a>
                                </li>
                                <li>
                                    <a href="/login" >
                                        Login
                                    </a>
                                </li>
                                
                            </ul>
                        </li>

                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                
                    </ul>
                    <div class="pricePagegr-mobile-point-buttonsWrap ">
                        <div class="pricePagegr-mobile-point-buttonsBox ">
                            <div class="pricePagegr-mobile-point-buttons ">
                                <a class="pricePagebtn pricePagenormal pricePagegr-gtitem-blue " href="/login">
                                                                                LOGIN
                                                                        </a>
                                                                    <a class="pricePagebtn pricePagenormal pricePagegreen " href="/signup">
                                    SIGN UP for FREE
                                </a>
                                                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pricePagerow pricePagegr-desktop-main-menu-wrap ">
            <div class="pricePagecontainer pricePageignore-additional-spaces pricePagegr-desktop-main-menu-container pricePagegr-space-fix ">
                <div class="pricePagegr-desktop-menu pricePageignore-additional-spaces ">
                    <div id="primaryMenu" class="pricePagenavbar " style={{minWidth:'100%',padding:'0px',margin:'0px'}}>
                        <ul class="pricePagenav pricePagenavbar-nav pricePagenav-pills pricePagegr-space-fix " style={{minWidth:'100%'}}>
                            <table style={{width:'100%'}}>
                                <tr>
                                    <td style={{float:'left'}}>
                                        <ul class="pricePagegr-main-menu-wrap pricePagegr-space-fix ">
                                        <li class="pricePagedesktopLogo pricePageignore-additional-spaces ">
                                            <a href="/" title="">
                                                <img class="pricePagelogo pricePagegr-normal-view " src={props.images.propertyAnalyticsLogoTransparent} alt="real estate property analytics" />
                                                <img class="pricePagelogo pricePagegr-scroll-view " src={props.images.propertyAnalyticsLogo} alt="real estate property analytics" />
                                            </a>
                                        </li>
                                        <li class="pricePagedropDown pricePagesolutions ">
                                            <a class="pricePagemenuNoLink pricePagedropdown-toggleX " data-hover="dropDown" data-toggle="dropDown">
                                                SOLUTION
                                            </a>
                                            <ul class="pricePagemenu-dropdown pricePagecol3 ">
                                                <li class="pricePagegr-space-fix pricePagegr-menu-nav-enclosure ">
                                                    <ul class="pricePagecol1 pricePagecolAll ">
                                                        <li class="pricePagegr-top-list ">
                                                            <a href="/homebuyers.html" class="">
                                                                BY INVESTOR TYPE
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-middle-list pricePagegr-space-fix ">
                                                            <ul class="pricePagegr-menu-left-side ">
                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/homebuyers.html" class="">
                                                                        For Home Buyers
                                                                    </a>
                                                                </li>
                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/property-flipping-investors.html" class="">
                                                                        For House Flipping Investors
                                                                    </a>
                                                                </li>
                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/rental-property-investors.html" class="">
                                                                        For Rental Property Investors
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="pricePagedropDown pricePagecompany ">
                                            
                                            <a class="menuNoLink pricePagedropdown-toggleX " data-hover="dropDown" data-toggle="dropDown">
                                                COMPANY
                                            </a>
                                         
                                            <ul class="pricePagemenu-dropdown pricePagecol2 ">
                                                <li class="pricePagegr-space-fix pricePagegr-menu-nav-enclosure ">
                                                    <ul class="pricePagecol1 pricePagecolAll ">
                                                        <li class="pricePagegr-middle-list pricePagegr-space-fix ">
                                                            <ul class="pricePagegr-menu-left-side ">
                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/about.html" class="">
                                                                        About Us
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        {/*
                                        <li class="pricePagegr-single-link pricePagepricing ">
                                            <a href="/pricing/" class="">
                                                PRICING
                                            </a>
                                        </li>
                                        */}
                                        </ul>
                                    </td>

                                    <td style={{float:'right'}}>
                                        <ul class="pricePagegr-main-menu-wrap pricePagegr-space-fix ">
                                        <li class="pricePagedropDown pricePageresources pricePagerightRefferer ">
                                            <a class="pricePagemenuNoLink pricePagedropdown-toggleX " data-hover="dropDown" data-toggle="dropDown">
                                                Resources
                                            </a>
                                            <ul class="pricePagemenu-dropdown pricePagegr-wrap-col2 pricePagegr-space-fix ">
                                                <li class="pricePagegr-wrap-col-left ">
                                                    <ul>
                                                        <li>
                                                            <ul class="pricePagecol1 pricePagecolAll ">
                                                                <li class="pricePagegr-middle-list pricePagegr-space-fix ">
                                                                    <ul class="pricePagemenugr-left-side ">
                                                                        <li class="pricePagelevel2 ">
                                                                            <a href="/blog" >
                                                                                Blog
                                                                            </a>
                                                                        </li>
                                                                        <li class="pricePagelevel2 ">
                                                                            <a href="/faq.html" class="">
                                                                                FAQ
                                                                            </a>
                                                                        </li>
                                                               
                                                                    </ul>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="pricePagedropDown pricePagesupport pricePagerightRefferer ">
                                            <a class="pricePagemenuNoLink ">
                                                Support
                                            </a>
                                            <ul class="pricePagemenu-dropdown pricePagecol2 ">
                                                <li class="pricePagegr-space-fix pricePagegr-menu-nav-enclosure ">
                                                    <ul class="pricePagecol1 pricePagecolAll ">
                                                        <li class="pricePagegr-middle-list pricePagegr-space-fix ">
                                                            <ul class="pricePagegr-menu-left-side ">
                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/faq.html" >
                                                                        FAQ
                                                                    </a>
                                                                </li>
                                                     
                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/contactus" >
                                                                        Contact Us
                                                                    </a>
                                                                </li>
                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/login" >
                                                                        Login
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        
                                        <li class="pricePagegr-desktop-login pricePagegr-desktop-login-blue ">
                                            <a href="/login">
                                                <img class="pricePagegr-menu-login-icon " src={props.images.loginIconBlue} alt="Login" border="0"/>
                                                <span class="pricePagegr-menu-login-text ">
                                                                Login
                                                            </span>
                                            </a>
                                        </li>
                                        <li class="pricePagegr-desktop-login pricePagedesktopLoginWhite ">
                                            <a href="/login">
                                                <img class="pricePagegr-menu-login-icon " src={props.images.loginIconWhite} alt="Login" border="0"/>
                                                <span class="pricePagegr-menu-login-text ">
                                                                Login
                                                            </span>
                                            </a>
                                        </li>

                                        <li class="pricePagegr-contact-more-info pricePagegr-contact-more-info-blue ">
                                            
                                            <a class="pricePagebtn pricePagegr-gtitem-blue " href="/login">
                                                LOGIN
                                            </a>
                                            
                                        </li>
                                        {props.isUserLoggedIn && 
                                        
                                        <li class="pricePagegr-contact-more-info pricePagegr-contact-more-info-blue ">
                                            
                                            <a class="pricePagebtn pricePagegr-gtitem-blue "  onClick={logOutUser}>
                                                LOGOUT
                                            </a>
                                            
                                        </li>
                                        }

                                        <li class="pricePagegr-contact-more-info pricePagegr-contact-more-info-white ">
                                                <a class="pricePagebtn pricePagegr-gtitem-white " href="/login">
                                                LOGIN
                                                </a>
                                        </li>

                                        {props.isUserLoggedIn && 
                                        <li class="pricePagegr-contact-more-info pricePagegr-contact-more-info-white ">
                                                <a class="pricePagebtn pricePagegr-gtitem-white " onClick={logOutUser}>
                                                LOGOUT
                                                </a>
                                        </li>
                                        }

                                        <li class="pricePagegr-signup-nomoney-menu ">
                                            <a class="pricePagebtn pricePagegreen " href="/signup">
                                                SIGN UP for FREE
                                            </a>
                                        </li>
                                        </ul>
                                    </td>
                                </tr>
                            </table>
    
                        </ul>
                    
                    </div>
                    
                    <div class="pricePagegr-desktop-search " id="desktopChannelSearch">
                        <div class="pricePagegr-desktop-search-item-enclosure " id="channel-search">

                        </div>
                    </div>
                </div>
            </div>
        </div>
        </header>
            <div class="pricePagegr-space-fix "></div>
            {/* End Header */}
            {/*  Start Content  */}
            <div class="pricePagegr-enclose-all ">
                <div class="pricePagepricing ">

                <div class="pricePagegr-entry-page-rectangle-container pricePagegr-the-low-menu ">
        <div class="pricePagegr-entry-page-rectangle-wrap ">
        <div class="pricePagecontainer pricePageignore-additional-spaces ">
            <div class="pricePagegr-first-info-special-wrapper pricePagegr-space-fix ">
            <h1 class="pricePageintroPageBannerTitle pricePagegr-color-white pricePagetext-center ">
            Simple, Affordable Pricing
            </h1>
            <h4 class="pricePagegr-section-title2 pricePagetext-center pricePagewhite ">
                No monthly subscriptions—simply pay for the credits you need. <br/>
               The more you buy, the lower your cost per credit.
            </h4>

            {/*
            <div style={{paddingTop:'30px'}}>
                <center>
                <table>
                    <tr>
                    <td>

                        <input
                            className="react-switch-checkbox"
                            id={`react-switch-new`}
                            type="checkbox" 
                            onChange={props.handleFrequencyChange}
                        />
                        <label
                            className="react-switch-label"
                            htmlFor={`react-switch-new`}
                        >
                            <span className={`react-switch-button`} />
                        </label>

                    </td>
                    <td style={{color:'#ffffff',paddingLeft:'10px'}}><div style={{marginTop:'15px'}}>Pay annually and save up to 17%</div></td>
                    </tr> 
                </table>
                </center>
            </div>
             */}

            </div>
        </div>
        </div>

        </div>

        {/* START Section1  */}
        <div class="pricePagegr-encloser-gray pricePagegr-encloser-container pricePagesection1 ">
        <div class="pricePagecontainerPrice pricePageignore-additional-spaces ">
        <div class="pricePagerow pricePageignore-additional-spaces ">
            <div class="pricePagegr-enclose-pricing-container ">
            <div class="pricePagegr-pricing-sub-menu pricePagegr-space-fix ">
                <div class="pricePagegr-most-popular-wrap ">

                {/* First Plan  */}
                <div class="pricePagegr-pricing-sub-menu-item1 pricePagegr-pricing-sub-menuItemAll pricePagegr-tile-price-top-space ">
                    <div class="pricePagegr-most-popular-wrap pricePagegr-encloser-white pricePagegr-bottom-border-blue ">
                    <h5 class="pricePagegr-most-popular pricePagegr-encloser-blue pricePagewhite pricePagegr-spaces-0 pricePagefont400 ">
                        {creditPacks.starter.name}
                    </h5>
                    <div class="pricePagegr-enclose-top-item ">
                        <h4 class="pricePagecolorBlueX pricePagefont500 pricePagetext-center pricePagegr-bottom-spaces-0 pricePagegr-price-amount-top-space ">
                        
                        <center>
                            <table>
                                <tr>
                                <td style={{fontSize:'45px',fontWeight:'bold'}}>${creditPacks.starter.price}</td>
                                </tr>
                            </table>
                           
                        </center>

                        </h4>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px'}}>
                        One-time purchase
                        </div>

                        <h4 style={{fontWeight:'bold'}}>{formatCredits(creditPacks.starter.credits)}<br></br>credits</h4>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px', fontSize:'18px'}}>
                        ($1.00 / 1k credits)
                        </div>

                        {!props.isUserLoggedIn && 
                                    
                         <div>      
                            <div class="pricePagegr-signup-button pricePagetext-center ">
                                <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " href={"/signup?type=trial&plan=advanced&frequency="}><span>Try it for FREE</span></a>
                            </div>
                            
                            <div class="pricePagegr-no-credit-card pricePagetext-center ">
                            or <a style={{fontSize:"17px",fontWeight:"bold", color: "blue", cursor: "pointer"}} onClick={() => props.purchaseCreditPack(creditPacks.starter.key)}><u>Buy Credits</u></a>

                            </div>
                            
                            <div class="pricePagegr-no-credit-card pricePagetext-center ">
                                <div style={{paddingTop:'5px', paddingBottom: '15px'}}>
                                7 day free trial<br></br>    
                                No credit card required.
                                </div>

                            </div>
                        </div>
                        
                        
                        }


                        {props.isUserLoggedIn && 
                            <span>
                          
                                <div>
                                 
                                    <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a" onClick={() => props.purchaseCreditPack(creditPacks.starter.key)}><span>Buy Credits</span></a>

                                </div>
                            
                            
                            {props.isUserLoggedIn && (
                                <div class="pricePagetext-center" style={{
                                    marginBottom: '20px',
                                    fontWeight: 'bold'
                                }}>
                                    Credits left
                                    <div class="pricePagetext-center" style={{
                                    fontSize: '25px',
                                    fontWeight: 'bold',
                                    marginBottom: '20px',
                                    color: '#3474ff'
                                }}>
                                    {formatCredits(props.creditBalance)} 
                                    </div>
                                </div>
                            )}

                            {props.creditPurchaseMessage && (
                                <div class="pricePagetext-center" style={{
                                    backgroundColor: '#f4f1ff',
                                    border: '1px solid #583bec',
                                    borderRadius: '6px',
                                    padding: '12px',
                                    margin: '0 auto 25px auto',
                                    maxWidth: '850px'
                                }}>
                                    {props.creditPurchaseMessage}
                                </div>
                            )}
                            
                            </span>
                        }

                        
                    </div>
                    <div class="pricePagepartnerTestWrap ">
                       
                      <tsble style={{textAlign:'left'}}>
                            <tr  style={{textAlign:'left'}}>
                                <td><img src="../images/checked-blue.png" border="0" style={{height:'9px'}}/></td>
                                <td style={{paddingLeft:'5px'}}>Never expires</td>
                            </tr>
                            <tr>
                                <td style={{textAlign:'left', paddingTop:'10px'}}><img src="../images/checked-blue.png" border="0"  style={{height:'9px'}}/></td>
                                <td  style={{paddingLeft:'5px', paddingTop:'10px'}}>
                            Only used for:

                            <tsble style={{textAlign:'left'}}>
                                    <tr  style={{textAlign:'left'}}>
                                        <td style={{paddingTop:'10px'}}><img src="../images/checked-green.png" border="0" style={{height:'9px'}}/></td>
                                        <td style={{fontWeight:'11px', paddingLeft:'5px', paddingTop:'10px'}}>Single-property lookups</td>
                                    </tr>
                                    <tr  style={{textAlign:'left', paddingBottom:'20px'}}>
                                        <td style={{paddingTop:'10px'}}><img src="../images/checked-green.png" border="0"  style={{height:'9px'}}/></td>
                                        <td style={{fontWeight:'11px', paddingLeft:'5px', paddingTop:'10px'}}>Advanced searches</td>
                                    </tr>
                                </tsble>

                                </td>
                            </tr>
                        </tsble>
                    </div>
                    </div>
                </div>

                {/* Second Plan  */}
                <div class="pricePagegr-pricing-sub-menu-item2 pricePagegr-pricing-sub-menuItemAll ">
                    <div class="pricePagegr-most-popular-wrap pricePagegr-encloser-white pricePagegr-bottom-border-green ">
                    <h5 class="pricePagegr-most-popular pricePagegr-encloser-green pricePagewhite pricePagegr-spaces-0 pricePagefont400 ">
                        {creditPacks.standard.name}
                    </h5>
                    <div class="pricePagegr-enclose-top-item ">
                        <h4 class="pricePagecolorGreenX pricePagefont500 pricePagetext-center pricePagegr-bottom-spaces-0 pricePagegr-price-amount-top-space ">
 
                        <center>
                            <table>
                                <tr>
                                    <td style={{fontSize:'45px',fontWeight:'bold'}}>${creditPacks.standard.price}</td>
                                </tr>
                            </table>
                        </center>
                        </h4>
                        <h5 class="pricePagefont500 pricePagetext-center ">
                        <b>Most Popular</b>
                        </h5>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px'}}>
                        One-time purchase
                        </div>
                        <h4 style={{fontWeight:'bold'}}>{formatCredits(creditPacks.standard.credits)}<br></br>credits</h4>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px', fontSize:'18px'}}>
                        ($0.75 / 1k credits)
                        </div>

                        {!props.isUserLoggedIn && 
                                    
                            <div>      
                                <div class="pricePagegr-signup-button pricePagetext-center ">
                                    <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " href={"/signup?type=trial&plan=advanced&frequency="}><span>Try it for FREE</span></a>
                                </div>
                                
                                <div class="pricePagegr-no-credit-card pricePagetext-center ">
                                or <a style={{fontSize:"17px",fontWeight:"bold", color: "blue", cursor: "pointer"}} onClick={() => props.purchaseCreditPack(creditPacks.standard.key)}><u>Buy Credits</u></a>
                                </div>

                                <div class="pricePagegr-no-credit-card pricePagetext-center ">
                                    <div style={{paddingTop:'5px', paddingBottom: '15px'}}>
                                    7 day free trial<br></br>    
                                    No credit card required.
                                    </div>

                                </div>

                            </div>
                                    
                        }
            
            
                        {props.isUserLoggedIn && 
                            <span>
                         {/*   {(props.user.planType !== "trial") &&  */}
                                <div>
                                    
                                    <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a" onClick={() => props.purchaseCreditPack(creditPacks.standard.key)}><span>Buy Credits</span></a>

                                </div>
                         {/*  } */}

                             {props.isUserLoggedIn && (
                                <div class="pricePagetext-center" style={{
                                    marginBottom: '20px',
                                    fontWeight: 'bold'
                                }}>
                                    Credits left
                                    <div class="pricePagetext-center" style={{
                                    fontSize: '25px',
                                    fontWeight: 'bold',
                                    marginBottom: '20px',
                                    color: '#3474ff'
                                }}>
                                    {formatCredits(props.creditBalance)} 
                                    </div>
                                </div>
                            )}

                            {props.creditPurchaseMessage && (
                                <div class="pricePagetext-center" style={{
                                    backgroundColor: '#f4f1ff',
                                    border: '1px solid #583bec',
                                    borderRadius: '6px',
                                    padding: '12px',
                                    margin: '0 auto 25px auto',
                                    maxWidth: '850px'
                                }}>
                                    {props.creditPurchaseMessage}
                                </div>
                            )}

                            </span>
                        }
                        
                    </div>
                         <div class="pricePagepartnerTestWrap">
                       
                      <tsble style={{textAlign:'left'}}>
                            <tr  style={{textAlign:'left'}}>
                                <td><img src="../images/checked-blue.png" border="0" style={{height:'9px'}}/></td>
                                <td style={{paddingLeft:'5px'}}>Never expires</td>
                            </tr>
                            <tr>
                                <td style={{textAlign:'left', paddingTop:'10px'}}><img src="../images/checked-blue.png" border="0"  style={{height:'9px'}}/></td>
                                <td  style={{paddingLeft:'5px', paddingTop:'10px'}}>
                            Only used for:

                            <tsble style={{textAlign:'left'}}>
                                    <tr  style={{textAlign:'left'}}>
                                        <td style={{paddingTop:'10px'}}><img src="../images/checked-green.png" border="0" style={{height:'9px'}}/></td>
                                        <td style={{fontWeight:'11px', paddingLeft:'5px', paddingTop:'10px'}}>Single-property lookups</td>
                                    </tr>
                                    <tr  style={{textAlign:'left', paddingBottom:'20px'}}>
                                        <td style={{paddingTop:'10px'}}><img src="../images/checked-green.png" border="0"  style={{height:'9px'}}/></td>
                                        <td style={{fontWeight:'11px', paddingLeft:'5px', paddingTop:'10px'}}>Advanced searches</td>
                                    </tr>
                                </tsble>

                                </td>
                            </tr>
                        </tsble>
                    </div>
                    </div>
                </div>
                
                {/* Third Plan  */}
                <div class="pricePagegr-pricing-sub-menu-item3 pricePagegr-pricing-sub-menuItemAll pricePagegr-tile-price-top-space ">
                    <div class="pricePagegr-most-popular-wrap pricePagegr-encloser-white pricePagegr-bottom-border-purple ">
                    <h5 class="pricePagegr-most-popular pricePagegr-encloser-purple pricePagewhite pricePagegr-spaces-0 pricePagefont400 ">
                        {creditPacks.scale.name}
                    </h5>
                    <div class="pricePagegr-enclose-top-item ">

                        <h4 class="pricePagefont500 pricePagetext-center pricePagegr-bottom-spaces-0 pricePagegr-price-amount-top-space ">
                        <center>
                            <table>
                                <tr>
                                 <td style={{fontSize:'45px',fontWeight:'bold'}}>${creditPacks.scale.price}</td>
                                </tr>
                            </table>
                        </center>
                        </h4>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px'}}>
                        One-time purchase
                        </div>

                        <h4 style={{fontWeight:'bold'}}>{formatCredits(creditPacks.scale.credits)}<br></br>credits</h4>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px', fontSize:'18px'}}>
                        ($0.57 / 1k credits)
                        </div>

                        {!props.isUserLoggedIn && 
                                    
                          <div>      
                            <div class="pricePagegr-signup-button pricePagetext-center ">
                                <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " href={"/signup?type=trial&plan=advanced&frequency="}><span>Try it for FREE</span></a>
                            </div>
                            
                            <div class="pricePagegr-no-credit-card pricePagetext-center ">
                            or <a style={{fontSize:"17px",fontWeight:"bold", color: "blue", cursor: "pointer"}} onClick={() => props.purchaseCreditPack(creditPacks.scale.key)}><u>Buy Credits</u></a>
                            </div>

                            <div class="pricePagegr-no-credit-card pricePagetext-center ">
                                <div style={{paddingTop:'5px', paddingBottom: '15px'}}>
                                7 day free trial<br></br>    
                                No credit card required.
                                </div>

                            </div>
                        </div>
                                    
                        }
            
            
                        {props.isUserLoggedIn && 
                            <span>
                            
                                <div>
                                    
                                    <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a" onClick={() => props.purchaseCreditPack(creditPacks.scale.key)}><span>Buy Credits</span></a>

                                </div>
                            
                            
                             {props.isUserLoggedIn && (
                                <div class="pricePagetext-center" style={{
                                    marginBottom: '20px',
                                    fontWeight: 'bold'
                                }}>
                                    Credits left
                                    <div class="pricePagetext-center" style={{
                                    fontSize: '25px',
                                    fontWeight: 'bold',
                                    marginBottom: '20px',
                                    color: '#3474ff'
                                }}>
                                    {formatCredits(props.creditBalance)} 
                                    </div>
                                </div>
                            )}
                            
                            {props.creditPurchaseMessage && (
                                <div class="pricePagetext-center" style={{
                                    backgroundColor: '#f4f1ff',
                                    border: '1px solid #583bec',
                                    borderRadius: '6px',
                                    padding: '12px',
                                    margin: '0 auto 25px auto',
                                    maxWidth: '850px'
                                }}>
                                    {props.creditPurchaseMessage}
                                </div>
                            )}

                            </span>
                        }

                    </div>
                         <div class="pricePagepartnerTestWrap ">
                       
                         <tsble style={{textAlign:'left'}}>
                            <tr  style={{textAlign:'left'}}>
                                <td><img src="../images/checked-blue.png" border="0" style={{height:'9px'}}/></td>
                                <td style={{paddingLeft:'5px'}}>Never expires</td>
                            </tr>
                            <tr>
                                <td style={{textAlign:'left', paddingTop:'10px'}}><img src="../images/checked-blue.png" border="0"  style={{height:'9px'}}/></td>
                                <td  style={{paddingLeft:'5px', paddingTop:'10px'}}>
                            Only used for:

                            <tsble style={{textAlign:'left'}}>
                                    <tr  style={{textAlign:'left'}}>
                                        <td style={{paddingTop:'10px'}}><img src="../images/checked-green.png" border="0" style={{height:'9px'}}/></td>
                                        <td style={{fontWeight:'11px', paddingLeft:'5px', paddingTop:'10px'}}>Single-property lookups</td>
                                    </tr>
                                    <tr  style={{textAlign:'left', paddingBottom:'20px'}}>
                                        <td style={{paddingTop:'10px'}}><img src="../images/checked-green.png" border="0"  style={{height:'9px'}}/></td>
                                        <td style={{fontWeight:'11px', paddingLeft:'5px', paddingTop:'10px'}}>Advanced searches</td>
                                    </tr>
                                </tsble>

                                </td>
                            </tr>
                        </tsble>


                    </div>
                    </div>
                </div>

                {/* Fourth Plan  */}
                <div class="pricePagegr-pricing-sub-menu-item4 pricePagegr-pricing-sub-menuItemAll pricePagegr-tile-price-top-space ">
                    <div class="pricePagegr-most-popular-wrap pricePagegr-encloser-white pricePagegr-bottom-border-dark-purple pricePagegr-left-border ">
                    <h5 class="pricePagegr-most-popular pricePagegr-encloser-dark-purple pricePagewhite pricePagegr-spaces-0 pricePagefont400 ">
                        {creditPacks.ultimate.name}
                    </h5>
                    <div class="pricePagegr-enclose-top-item ">
                        
                        <h4 class="pricePagecolorDarkPurpleX pricePagefont500 pricePagetext-center pricePagegr-bottom-spaces-0 pricePagegr-price-amount-top-space ">
                        <center>
                            <table>
                                <tr>
                                 <td style={{fontSize:'45px',fontWeight:'bold'}}>${creditPacks.ultimate.price}</td>
                                </tr>
                            </table>
                        </center>
                        </h4>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px'}}>
                        One-time purchase
                        </div>
                        
                        <h4 style={{fontWeight:'bold'}}>{formatCredits(creditPacks.ultimate.credits)}<br></br>credits</h4>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px', fontSize:'18px'}}>
                        ($0.50 / 1k credits)
                        </div>

                        {!props.isUserLoggedIn && 
                              
                        <div>      
                            <div class="pricePagegr-signup-button pricePagetext-center ">
                                <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " href={"/signup?type=trial&plan=advanced&frequency="}><span>Try it for FREE</span></a>
                            </div>
                            
                            <div class="pricePagegr-no-credit-card pricePagetext-center ">
                            or <a style={{fontSize:"17px",fontWeight:"bold", color: "blue", cursor: "pointer"}} onClick={() => props.purchaseCreditPack(creditPacks.ultimate.key)}><u>Buy Credits</u></a>
                            </div>
                            <div class="pricePagegr-no-credit-card pricePagetext-center ">
                                <div style={{paddingTop:'5px', paddingBottom: '15px'}}>
                                7 day free trial<br></br>    
                                No credit card required.
                                </div>

                            </div>
                        </div>
                        }


                        {props.isUserLoggedIn && 
                            <span>
                           
                                <div>
                                    
                                    <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a" onClick={() => props.purchaseCreditPack(creditPacks.ultimate.key)}><span>Buy Credits</span></a>

                                </div>
                            
                             {props.isUserLoggedIn && (
                                <div class="pricePagetext-center" style={{
                                    marginBottom: '20px',
                                    fontWeight: 'bold'
                                }}>
                                    Credits left
                                    <div class="pricePagetext-center" style={{
                                    fontSize: '25px',
                                    fontWeight: 'bold',
                                    marginBottom: '20px',
                                    color: '#3474ff'
                                }}>
                                    {formatCredits(props.creditBalance)} 
                                    </div>
                                </div>
                            )}

                            {props.creditPurchaseMessage && (
                                <div class="pricePagetext-center" style={{
                                    backgroundColor: '#f4f1ff',
                                    border: '1px solid #583bec',
                                    borderRadius: '6px',
                                    padding: '12px',
                                    margin: '0 auto 25px auto',
                                    maxWidth: '850px'
                                }}>
                                    {props.creditPurchaseMessage}
                                </div>
                            )}
                            
                            </span>
                        }
                        
                    </div>
                         <div class="pricePagepartnerTestWrap ">
                       
                      <tsble style={{textAlign:'left'}}>
                            <tr  style={{textAlign:'left'}}>
                                <td><img src="../images/checked-blue.png" border="0" style={{height:'9px'}}/></td>
                                <td style={{paddingLeft:'5px'}}>Never expires</td>
                            </tr>
                            <tr>
                                <td style={{textAlign:'left', paddingTop:'10px'}}><img src="../images/checked-blue.png" border="0"  style={{height:'9px'}}/></td>
                                <td  style={{paddingLeft:'5px', paddingTop:'10px'}}>
                            Only used for:

                            <tsble style={{textAlign:'left'}}>
                                    <tr  style={{textAlign:'left'}}>
                                        <td style={{paddingTop:'10px'}}><img src="../images/checked-green.png" border="0" style={{height:'9px'}}/></td>
                                        <td style={{fontWeight:'11px', paddingLeft:'5px', paddingTop:'10px'}}>Single-property lookups</td>
                                    </tr>
                                    <tr  style={{textAlign:'left', paddingBottom:'20px'}}>
                                        <td style={{paddingTop:'10px'}}><img src="../images/checked-green.png" border="0"  style={{height:'9px'}}/></td>
                                        <td style={{fontWeight:'11px', paddingLeft:'5px', paddingTop:'10px'}}>Advanced searches</td>
                                    </tr>
                                </tsble>

                                </td>
                            </tr>
                        </tsble>
                    </div>
                    </div>
                </div>

                </div>
            </div>
            </div> 
            <div class="pricePagegr-special-pricing-submenu-enclosureBox pricePagegr-top-spaces40 " style={{backgroundColor:'#583bec',width:'100%'}}>
            <div class="pricePagegr-special-pricing-submenu-enclosure ">
                <div class="pricePagegr-enclose-top-item pricePagegr-space-fix ">
                <div class="pricePagecolItemAll pricePagecolItem1 ">
                    <h5 class="pricePagecolorBlueLight pricePagefont500 pricePagewhite pricePagegr-top-spaces0 pricePagegr-bottom-spaces-a " style={{color:'#ffffff'}}>
                    Custom Pricing
                    </h5>
                    <div class="pricePagewhite ">
                    We provide customized plans to fit your specific needs specifically for bigger companies that require more than 10 logins.
                    </div>
                </div>
        
                <div class="pricePagecolItemAll pricePagecolItem5 ">
                    <div class="pricePagegr-signup-button pricePagetext-center ">
                    <a class="pricePagebtn pricePagenormal pricePagegr-gtitem-light-blue pricePagegr-spaces-a " href="/contactus" style={{backgroundColor:'#ffffff',fontWeight:'bold'}}><span>CONTACT SALES</span></a>
                    </div>
                </div>
                </div>
            </div>
            </div>
            <div class="pricePagegr-top-spaces40 pricePagedetailsDecide " id="openPrincigDetails" style={{width:'100%'}}>
            <h4 class="pricePagegr-top-spaces0 pricePagetext-center ">
                Can't decide which plan is right for you?
            </h4>
            <div class="pricePagecomparationBox pricePagegr-space-fix ">



                <div class="pricePagegr-comparing-plans pricePagegr-future-left-side ">

                <div class="pricePagegr-future-title " style={{textAlign:'center'}}>
                    No worries, you can change your plan any time without skipping a beat.
                </div>
                
                </div>

            </div>
            </div>
        </div>
        </div>
        </div>
        {/* END Section1  */}

        {/* START Section2  */}
        <div class="pricePagesection3 pricePagegr-encloser-gray pricePagegr-container1 ">
        <div class="pricePagecontainer pricePageignore-additional-spaces ">
        <div class="pricePagerow pricePageignore-additional-spaces ">
            <div class="pricePagegr-informational-client-whiteWrap " style={{width:'100%'}}>
            <div class="pricePagegr-informational-client-white-enclosure pricePagegr-space-fix ">
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-whiteTitle ">
                Included in All Plans:
                </div>
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-white ">
                <span class="pricePagegr-our-care-image "><img alt="Property Analysis" border="0" class="pricePagegr-image-responsive pricePagecenter-block " src={props.images.propertyAnalyticsFeatureBlue} /></span> <span class="pricePagegr-our-care-text ">Property
                <br />
                Analytics </span>
                </div>
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-white ">
                <span class="pricePagegr-our-care-image "><img alt="Advanced Searches" border="0" class="pricePagegr-image-responsive pricePagecenter-block " src={props.images.advancedSearchesBlue} /></span> <span class="pricePagegr-our-care-text ">Advanced
                <br />
                Searches</span>
                </div>
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-white ">
                <span class="pricePagegr-our-care-image "><img alt="Reporting and Analytics" border="0" class="pricePagegr-image-responsive pricePagecenter-block " src={props.images.reportingAndAnalyticsGreen} /></span> <span class="pricePagegr-our-care-text ">Reporting &amp;
                <br />
                Metrics</span>
                </div>
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-white ">
                <span class="pricePagegr-our-care-image "><img alt="Multiple Profiles" border="0" class="pricePagegr-image-responsive pricePagecenter-block " src={props.images.profilesFeatureBlue} /></span> <span class="pricePagegr-our-care-text ">Multiple
                <br />
                Profiles</span>
                </div>
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-white ">
                <span class="pricePagegr-our-care-image "><img alt="Financial Indicators" border="0" class="pricePagegr-image-responsive pricePagecenter-block " src={props.images.financialIndicatorsFeatureRed} /></span> <span class="pricePagegr-our-care-text ">Financial
                <br />
                Indicators</span>
                </div>
            </div>
            </div>
        </div>
        </div>
        </div>
        
        {/* END Section3  */}
        
        {/* START Section4  */}
        <div class="pricePagegr-space-fix pricePagesection4 pricePagegr-encloser-blue ">
        <div class="pricePagecontainer pricePageignore-additional-spaces ">
        <div class="pricePagerow pricePageignore-additional-spaces ">
            <h4 class="pricePagewhite pricePagetext-center pricePagegr-spaces-b " style={{textAlign:'center',width:'100%'}}>
            <div style= {{fontSize:'25px',fontWeight:'bold'}}>100% RISK FREE</div>
            This is why so many people and companies trust us
            </h4>
                <div class="pricePagegr-informational-client-whiteWrap ">
                    <div class="pricePagegr-informational-client-white-enclosure pricePagegr-space-fix pricePagegr-multiple-sections-5-enclosure ">
                        <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagewhite pricePagegr-informational-client-whiteTitle ">
                            Trusted by home buyers, real estate investors, realtors and bankers
                        </div>
            
                        <div class="pricePagecol-md-2 pricePagegr-spaces-b pricePagegr-informational-client-white ">
                            <a class="pricePagegr-icon-effect " href="/pricing">
                                <img class="pricePagegr-image-responsive pricePagecenter-block " src={props.images.freeTrial} alt="Free trial" border="0" style={{width:'135px',height:'119px'}}/>
                            </a>
                        </div>
                    
                        <div class="pricePagecol-md-2 pricePagegr-spaces-b pricePagegr-informational-client-white ">
                            
                                <img class="pricePagegr-image-responsive pricePagecenter-block " src={props.images.moneyBackGuarantee} alt="Money back guarantee" border="0"/>
                           
                        </div>
                    
                        <div class="pricePagecol-md-2 pricePagegr-spaces-b pricePagegr-informational-client-white ">
                           
                                <img class="pricePagegr-image-responsive pricePagecenter-block " src={props.images.cancelAnyTime} alt="Cancel anytime" border="0" style={{width:'200px',height:'131px'}}/>
                           
                        </div>
                    
                        <div class="pricePagecol-md-2 pricePagegr-spaces-b pricePagegr-informational-client-white ">
                          
                                <img class="pricePagegr-image-responsive pricePagecenter-block " src={props.images.satisfactionGurantee} alt="satisfaction gurantee" border="0" style={{width:'125px',height:'108px'}}/>
                           
                        </div>
                    
                        <div class="pricePagecol-md-2 pricePagegr-spaces-b pricePagegr-informational-client-white ">
                            
                                <img class="pricePagegr-image-responsive pricePagecenter-block " src={props.images.securedSsl} alt="Secured SSL" border="0" />
                            
                        </div>
                    
                    </div>
                </div>
        </div>
        </div>
        </div>
        
        {/* END Section4  */}
        
        {/* START Section6  */}
        <div class="pricePagewrapper pricePagesection6 pricePagegr-encloser-white pricePagegr-encloser-container ">
        <div class="pricePagecontainer pricePagenopadd ">
        <div class="pricePagerow ">
            <h2 class="pricePagegr-top-spaces0 pricePagetext-center pricePagegr-bottom-spaces-c " style={{width:'100%'}}>
                Frequently Asked Questions
            </h2>

            <div class="pricePagegr-enclose-team-enclosure ">
                <div class="pricePagegr-space-fix ">

                    <div class="pricePagecol-sm-6 ">

                        <div class="pricePageitemAll pricePageitem1 ">
                            <div>
                                <h5 class="pricePagequestion ">
                                    1. Do I need a credit card to try GoRepa?
                                </h5>

                                <p class="pricePageanswer pStyle">
                                    No. You can create a free GoRepa<sup style={{fontSize:'12px'}}>&#174;</sup> account and try the platform without entering a credit card. Once your free trial expires, simply purchase credits to continue using GoRepa.

                                </p>
                            </div>
                        </div>


                        <div class="pricePageitemAll pricePageitem2 ">
                            <div>
                                <h5 class="pricePagequestion ">
                                    2. How does GoRepa's credit system work?
                                </h5>

                                <p class="pricePageanswer pStyle">
                                    GoRepa uses a prepaid credit system instead of a monthly subscription. You purchase credits as needed, and credits are used when GoRepa performs property searches, research, AI-agent tasks, financial analysis, and other Property Intelligence operations on your behalf.
                                </p>
                            </div>
                        </div>


                        <div class="pricePageitemAll pricePageitem3 ">
                            <div>
                                <h5 class="pricePagequestion ">
                                    3. Do my credits expire?
                                </h5>

                                <p class="pricePageanswer pStyle">
                                    Purchased credits remain available in your account until they are used. There is no monthly subscription to maintain and no requirement to purchase credits on a recurring schedule.
                                </p>
                            </div>
                        </div>

                    </div>


                    <div class="pricePagecol-sm-6 ">

                        <div class="pricePageitemAll pricePageitem4 ">
                            <div>
                                <h5 class="pricePagequestion ">
                                    4. What uses credits?
                                </h5>

                                <p class="pricePageanswer pStyle">
                                    Credits are used when GoRepa performs work for you, including property research and analysis performed by its AI agents. Advanced Searches also use credits whenever they run in the background, whether or not matching properties are found.
                                </p>
                            </div>
                        </div>


                        <div class="pricePageitemAll pricePageitem5 ">
                            <div>
                                <h5 class="pricePagequestion ">
                                    5. Why does GoRepa use AI agents?
                                </h5>

                                <p class="pricePageanswer pStyle">
                                    GoRepa uses specialized AI agents to research properties, gather market information, evaluate data from multiple sources, and help build a more complete picture of each opportunity. GoRepa's financial engine then performs the calculations used to turn that information into clear green and red signals.
                                </p>
                            </div>
                        </div>


                        <div class="pricePageitemAll pricePageitem6 ">
                            <div>
                                <h5 class="pricePagequestion ">
                                    6. Is my credit card information stored by GoRepa?
                                </h5>

                                <p class="pricePageanswer pStyle">
                                    GoRepa does not store your credit card information. Payments are processed securely by <b>Stripe</b>, which maintains PCI-DSS compliance. You can read more about Stripe's PCI compliance <a href="https://stripe.com/guides/pci-compliance" target="_blank" rel="noopener noreferrer">here</a>.
                                </p>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
        </div>
        </div>
        
        {/* END Section6  */}
        </div>
                {/* Stop Loading Content  */}

                {/* Start Loading Bottom Blocks  */}
                <div class="pricePagegr-enclose-g-container pricePagegr-enclosed-rotate-wrap ">
                <div class="pricePagegr-enclosed-rotate ">
                    <div class="pricePagecontainer pricePageignore-additional-spaces ">
                        <div class="pricePagerow pricePagegr-space-fix ">
                            <div class="pricePagecol-md-8 pricePagegr-footer-left pricePagetextX pricePageignore-additional-spaces ">
                                <div>
                                    <div class="pricePagegr-start-text-enclosure pricePagetext-center ">
                                        <h5 class="pricePagewhite pricePagegr-spaces-0 ">
                                            Simplify your property search and analysis efforts. Try GoRepa<sup style={{fontsize:'12px'}}>&#174;</sup>.
                                        </h5>
                                        <div class="pricePagewhite ">
                                            The only real estate analytics platform that allows you to pick properties like you pick stocks with green and red signals.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pricePagecol-md-4 pricePagegr-footer-right pricePageignore-additional-spaces ">
                                <div>
                                    <div class="pricePagegr-start-button-enclosure pricePagetext-center ">
                                        <a class="pricePagebtn pricePagenormal pricePagegr-gtitem-white " href="/login">LOGIN</a>
                                        <a class="pricePagebtn pricePagenormal pricePagegreen " href="/signup">SIGN UP for FREE</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                
                {/* Stop Loading Bottom Blocks  */}
            </div>
            {/* Stop Content  */}

                    {/* Start Template Footer  */}
                    <footer class="pricePagev2 ">
                    <div class="pricePagefooter ">
                        <div class="">
                            <div class="pricePagerow ">
                                <div class="pricePagecontainer pricePageignore-additional-spaces ">
                                    <div class="pricePagegr-footer-wrap " style={{width:'100%'}}>
                                        <div class="pricePagegr-footer-top-wrap pricePagegr-space-fix ">
                                            <div class="pricePagegr-footer-top pricePagegr-space-fix ">
                                                <div class="pricePagecolAll pricePagecol1 ">
                                                    <ul class="pricePagegr-footer-enclose-wrap pricePagefooterNav ">
                                                        <li class="pricePagegr-footer-enclose-logo-wrap ">
                                                            <a class="pricePagegr-footer-enclose-logo " href="/">
                                                                <img class="pricePagelogo "style={{width:'55px'}} src={props.images.propertyAnalyticsLogoTransparent} alt="real estate property analytics" border="0"/>
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-title pricePagegr-footer-enclose-1 ">
                                                            <h5 class="pricePagegr-top-spaces10 pricePagegr-bottom-spaces-0 ">
                                                                Real Estate Property Analytics. Simplified.
                                                            </h5>
                                                        </li>
                                        
                                                        <li class="pricePagegr-social-box pricePagegr-space-fix pricePagegr-bottom-spaces-b ">
                                                            <ul class="pricePagesocial pricePagegr-space-fix ">
                                                                <li>
                                                                    <a class="pricePagegr-footer-flickr " href="https://www.instagram.com/gorepa.analytics/"  target="_blank">
                                                                        <img alt="instagram" border="0" class="pricePagegr-social-image pricePagegr-social-imageDark " src={props.images.instagramFooterWhite}/>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a class="pricePagegr-footer-linkedin " href="https://www.linkedin.com/company/gorepa/"  target="_blank">
                                                                        <img alt="linkedin" border="0" class="pricePagegr-social-image pricePagegr-social-imageDark " src={props.images.linkedinFooterWhite}/>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a class="pricePagegr-footer-twitter " href="https://www.twitter.com/GoRepaAnalytics"  target="_blank">
                                                                        <img alt="twitter" border="0" class="pricePagegr-social-image pricePagegr-social-imageDark " src={props.images.twitterFooterWhite}/>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a class="pricePagegr-footer-facebook " href="https://www.facebook.com/GoRepaAnalytics"  target="_blank">
                                                                        <img alt="facebook" border="0" class="pricePagegr-social-image pricePagegr-social-imageDark " src={props.images.facebookFooterWhite}/>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </div>
                                        
                                                <div class="pricePagecolAll pricePagecol3 ">
                                                    <ul class="pricePagefooterNav ">
                                                        <li class="pricePagegr-footer-enclose-1 ">
                                                            <a class="pricePagemenuNoLink ">
                                                                SOLUTION
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/homebuyers.html">
                                                                For Homebuyers
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/property-flipping-investors.html">
                                                                For Property Flipping Investors
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/rental-property-investors.html">
                                                                For Rental Property Investors
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="pricePagecolAll pricePagecol4 ">
                                                    <ul class="pricePagefooterNav ">
                                                        <li class="pricePagegr-footer-enclose-1 ">
                                                            <a class="pricePagemenuNoLink ">
                                                                COMPANY
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/about.html">
                                                                About Us
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="pricePagecolAll pricePagecol5 ">
                                                    <ul class="pricePagefooterNav pricePagegr-second-level ">
                                                        <li class="pricePagegr-footer-enclose-1 ">
                                                            <a class="pricePagemenuNoLink ">
                                                                RESOURCES
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/blog" >
                                                                Blog
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/faq.html">
                                                                FAQ
                                                            </a>
                                                        </li>
                                               
                                                    </ul>
                                                </div>
                                                <div class="pricePagecolAll pricePagecol6 ">
                                                    <ul class="pricePagefooterNav ">
                                                        <li class="pricePagegr-footer-enclose-1 ">
                                                            <a class="pricePagemenuNoLink ">
                                                                CONTACT US
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/login">
                                                                Login
                                                            </a>
                                                        </li>
                                                  
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/contactus">
                                                                Contact Us
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pricePagegr-footer-bottom-wrap ">
                                            <ul class="pricePagegr-space-fix ">
                                                <li class="pricePagegr-footer-enclose-policy pricePagegr-space-fix ">
                                                    <a href="/privacy.html">
                                                        Privacy Policy
                                                    </a>
                                                    <a href="/terms-of-service.html" >
                                                        Terms and Conditions
                                                    </a>
                                                </li>
                                                <li class="pricePagegr-footer-copyright ">
                                                    &#169; 2023 Copyright GoRepa<sup style={{fontsize:'12px'}}>&#174;</sup>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            


                </div>



        <script type="text/javascript" src="js/jquery.colorbox-min.js"></script>
        
</body>

</html>

);
};

const _PricingPageHTML = PricingPageHTML;
export { _PricingPageHTML as PricingPageHTML };